(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["notify-me-form"] && !Shopify.designMode) return;
  try {
    // Panel chrome (radius/border/background/overlay/heading color+font): single-
  // value properties, safe to carry as CSS custom properties on the panel itself.
  const NOTIFY_PANEL_VARS = {
    notifyRadius: { cssVar: '--notify-radius', unit: 'px' },
    notifyBorderWidth: { cssVar: '--notify-border-width', unit: 'px' },
    notifyBorderColor: { cssVar: '--notify-border-color' },
    notifyBg: { cssVar: '--notify-bg' },
    notifyPaddingTop: { cssVar: '--notify-padding-top', unit: 'px' },
    notifyPaddingBottom: { cssVar: '--notify-padding-bottom', unit: 'px' },
    notifyOverlay: { cssVar: '--notify-overlay' },
    notifyTextColor: { cssVar: '--notify-text' },
    notifyFontFamily: { cssVar: '--notify-font-family' },
  };

  const NOTIFY_TYPE_PRESETS = ['paragraph', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
  const NOTIFY_BUTTON_CLASSES = ['button', 'button-secondary', 'button-unstyled', 'button-custom'];

  document.addEventListener(
    'beforetoggle',
    (event) => {
      const panel = event.target;
      if (!panel.matches || !panel.matches('.notify-me__panel') || event.newState !== 'open') return;

      const trigger = document.querySelector(`[popovertarget="${panel.id}"]`);
      if (!trigger) return;
      const data = trigger.dataset;

      for (const [dataKey, { cssVar, unit }] of Object.entries(NOTIFY_PANEL_VARS)) {
        const value = data[dataKey];
        if (value) panel.style.setProperty(cssVar, unit ? `${value}${unit}` : value);
      }

      // Heading: text preset is a real theme typography class (paragraph /
      // h1-h6), same mechanism as blocks/email-signup.liquid, so it picks up
      // the theme's actual weight/size for that preset instead of a hardcoded
      // font-weight. Font size, alignment and color layer on top via inline
      // style / CSS var.
      const heading = panel.querySelector('[data-notify-me-heading]');
      if (heading) {
        if (data.notifyHeading) heading.textContent = data.notifyHeading;
        heading.classList.remove(...NOTIFY_TYPE_PRESETS);
        if (data.notifyHeadingPreset) heading.classList.add(data.notifyHeadingPreset);
        heading.style.textAlign = data.notifyHeadingAlign || '';
        heading.style.fontStyle = data.notifyHeadingItalic === 'true' ? 'italic' : '';
        heading.style.fontSize = data.notifyHeadingFontSize ? `${data.notifyHeadingFontSize}px` : '';
      }

      // Email field: border style (all/underline/none) is structural, so it's
      // a class swap — same for the text preset (kept independent from the
      // heading's preset so the two fonts don't have to match). Everything
      // else — only present when "Style" is Custom — is applied as DIRECT
      // inline style rather than a CSS variable. This theme has previously
      // hit a real bug where a self-referencing custom property broke
      // box-shadow entirely (see add-to-cart-button-styles.liquid); setting
      // inline style sidesteps that class of bug outright, since inline
      // always wins over the cascade with no variable indirection involved.
      // The button now lives INSIDE this group (not beside it) so a border
      // or underline set here visually wraps both, matching how
      // blocks/email-signup.liquid integrates its own button.
      const inputGroup = panel.querySelector('[data-notify-me-input-group]');
      const input = panel.querySelector('[data-notify-me-input]');
      if (inputGroup && input) {
        inputGroup.classList.remove(
          'notify-me__input-group--all',
          'notify-me__input-group--underline',
          'notify-me__input-group--none'
        );
        inputGroup.classList.add(`notify-me__input-group--${data.notifyInputBorderStyle || 'all'}`);

        inputGroup.style.borderWidth = data.notifyInputBorderWidth ? `${data.notifyInputBorderWidth}px` : '';
        inputGroup.style.borderRadius = data.notifyInputRadius ? `${data.notifyInputRadius}px` : '';
        inputGroup.style.backgroundColor = data.notifyInputBg || '';
        inputGroup.style.borderColor = data.notifyInputBorder || '';
        input.style.color = data.notifyInputText || '';

        input.classList.remove(...NOTIFY_TYPE_PRESETS);
        input.classList.add(data.notifyInputPreset || 'paragraph');
      }

      // Submit button: style reuses the theme's own button classes (button /
      // button-secondary / button-unstyled / button-custom) so "Primary" and
      // "Secondary" render with real theme button styling. For "Custom", the
      // colors are set as the SAME custom properties those classes already
      // read (--button-background-color etc.) via direct inline style, which
      // wins over .button-custom's own fallback declarations for them.
      const button = panel.querySelector('[data-notify-me-button]');
      if (button) {
        button.classList.remove(...NOTIFY_BUTTON_CLASSES);
        button.classList.add(data.notifyButtonStyle || 'button');

        button.style.setProperty('--button-background-color', data.notifyButtonBg || '');
        button.style.setProperty('--button-color', data.notifyButtonText || '');
        button.style.setProperty('--button-border-color', data.notifyButtonBorder || '');
        button.style.color = data.notifyButtonStyle === 'button-unstyled' ? data.notifyLinkText || '' : '';

        const label = button.querySelector('[data-notify-button-label]');
        const icon = button.querySelector('[data-notify-button-icon]');
        const isArrow = data.notifyButtonDisplay === 'arrow';
        if (label) {
          if (data.notifyButtonLabel) label.textContent = data.notifyButtonLabel;
          label.hidden = isArrow;
        }
        if (icon) icon.hidden = !isArrow;
        button.classList.toggle('notify-me__button--arrow', isArrow);
        if (isArrow) button.setAttribute('aria-label', data.notifyButtonLabel || 'Notify me');
        else button.removeAttribute('aria-label');
      }
    },
    true
  );

  // When this popup renders inside a carousel slide (e.g. a sold-out
  // product in the homepage's "Latest Arrivals" carousel), the slideshow's
  // own drag-to-swipe handling (assets/slideshow.js #handleMouseDown)
  // listens for 'mousedown' bubbling up from anywhere inside its slides
  // and calls preventDefault() on it unconditionally, to support swipe
  // gestures. That also cancels the browser's default "focus this input"
  // action tied to mousedown. The popup is promoted to the browser's top
  // LAYER for painting once open (via the Popover API), but it's still a
  // DOM descendant of the slide underneath — top-layer promotion only
  // changes paint order, not where events bubble — so that
  // preventDefault() still reaches (and silently blocks) clicks on this
  // popup's own email field. Buttons aren't affected: their 'click' fires
  // regardless of what happened to 'mousedown'. Stopping propagation here,
  // in the capture phase (which always runs before the slideshow's bubble-
  // phase listener), keeps the fix scoped to this popup instead of editing
  // the shared slideshow component.
  document.addEventListener(
    'mousedown',
    (event) => {
      if (event.target instanceof Element && event.target.closest('.notify-me__panel')) {
        event.stopPropagation();
      }
    },
    true
  );

  // Submission is a real full-page POST (see doc comment above for why —
  // short version: Cloudflare's bot challenge on this store's /contact
  // endpoint can only be completed by an actual page navigation, not fetch).
  // On success, Shopify redirects back to this form's #anchor. Detect that
  // on load and reopen the popover with a confirmation instead of the form.
  document.addEventListener('DOMContentLoaded', () => {
    if (!location.hash.startsWith('#notify-me-panel-')) return;

    const panel = document.querySelector(location.hash);
    if (!panel || !panel.matches('.notify-me__panel')) return;

    const form = panel.querySelector('[data-notify-me-form]');
    const message = panel.querySelector('[data-notify-me-message]');
    if (form) form.hidden = true;
    if (message) {
      message.textContent = "Thanks — we'll email you when it's back in stock.";
      message.classList.remove('notify-me__message--error');
      message.hidden = false;
    }
    if (panel.showPopover) panel.showPopover();
  });
  } catch(e) { console.error(e); }
})();

})();
